module.exports = __webpack_public_path__ + "media/images/partners_page/personal_shopper_bags_v0-58a482872969f94724835e35fae93088.png";